module.exports = __webpack_public_path__ + "cd15a8eb0e7abcbd28928f1fddfc2cd0.pdf";